import React from "react";

const IconLabel = ({ icon, color, label }) => {
  const iconClassName = `rounded-full h- w-10 h-10 mr-2 flex justify-center items-center bg-${color}`;
  const labelClassName = `text-${color}`;

  return (
    <div className="flex justify-start items-center mb-4">
      <div className={iconClassName}>{icon}</div>
      <p className={labelClassName}>{label}</p>
    </div>
  );
};

export default IconLabel;
